const timeZoneMapping = {
    "Eastern Standard Time (EST)": "America/New_York",
    "Central Standard Time (CST)": "America/Chicago",      
    "Pacific Standard Time (PST)": "America/Los_Angeles",  
    "Mountain Time (MT)": "America/Denver",
    "Mountain Standard Time (MST)":"America/Denver",                
    "Alaska Standard Time (AST)": "America/Anchorage",     
    "Hawaii-Aleutian Standard Time (HST)": "Pacific/Honolulu",
    'Hawaiian Standard Time': 'Pacific/Honolulu',
    'Eastern Standard Time': 'America/New_York',
    'Central Standard Time': 'America/Chicago',
    'Mountain Standard Time': 'America/Denver',
    'Pacific Standard Time': 'America/Los_Angeles',
    'Alaska Standard Time': 'America/Anchorage',
    'Alaskan Standard Time': 'America/Anchorage',
    'Atlantic Standard Time': 'America/Halifax',
    'Newfoundland Standard Time': 'America/St_Johns',
    'Argentina Standard Time': 'America/Argentina/Buenos_Aires',
    'Brazil Standard Time': 'America/Sao_Paulo',
    'Central America Standard Time': 'America/Guatemala',
    'Pacific SA Standard Time': 'America/Santiago',
    'Venezuela Standard Time': 'America/Caracas',
    'UTC': 'Etc/UTC',
    'GMT Standard Time': 'Europe/London',
    'Indian Standard Time (IST)': 'Asia/Kolkata',
    // Add more mapping if required 
  } as const;
  
  // return the timezoneMapping keys as a list
  export const timeZoneCollection = Object.keys(timeZoneMapping).map((key) => {
    return { label: key, value: key };
  });

  export type TimeZoneKey = keyof typeof timeZoneMapping;  
  
  export function getTzIdentifier(timezoneName: TimeZoneKey): string {
    return timeZoneMapping[timezoneName];
  }

  /** Returns the IANA identifier for any TZ string, or undefined if not found. */
  export function resolveIanaZone(tz: string): string | undefined {
    return (timeZoneMapping as Record<string, string>)[tz];
  }